export default __webpack_public_path__ + "images/8defb2a3d6abfe9ff3bd9b4b6df0882c.svg";